import React from 'react';
import moment from 'moment';
import { useLocalisation } from '@3plearning/lingui-cdn';
import { t } from '@lingui/macro';

import css from './topic-box.scss';
import { getProgressBoxClassName } from './topic-box';
import { ASSIGNMENT_RESULT_TYPES } from '../../../../../components/assignment-result/assignment-result-reducer';

const { VOLUNTARY } = ASSIGNMENT_RESULT_TYPES;

export const Attempt = (assignments) => {
    const { i18n } = useLocalisation();
    const { resultAccuracy, assignmentStartDate, assignmentType } = assignments;

    const ASSIGNMENT_ITEM_TEXT = {
        Assigned: i18n._(t`Assignment Item - Assigned - Label`),
        Voluntary: i18n._(t`Assignment Item - Voluntary - Label`)
    };

    const getIsFocusedResultClass = (isFocusedResult) =>
        isFocusedResult ? css['is-focused-result'] : '';

    const progressColor = getProgressBoxClassName(resultAccuracy);

    const assignmentTypeText =
        assignmentType === VOLUNTARY
            ? ASSIGNMENT_ITEM_TEXT.Voluntary
            : ASSIGNMENT_ITEM_TEXT.Assigned;

    return (
        <div className={css.wrapper} key={assignmentStartDate}>
            <div
                className={`${
                    css.circle
                } ${progressColor} ${getIsFocusedResultClass(
                    assignments.isFocusedResult
                )}`}
            />
            <div className={css['connect-block']} />
            <div className={css['tooltip-wrapper']}>
                <div className={css['assign-info']}>
                    {assignmentTypeText}:{' '}
                    {moment(assignmentStartDate).format('DD/MM/YY')}
                </div>
                <div className={`${css['accuracy-info']} ${progressColor}`}>
                    {resultAccuracy}%
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./containers/skill-quests-mastery/student/components/topic-box/attempt.js